

function params(FRN_page){

  if(typeof window === 'object'){
    return parse(window.location.search.substring(1))
  }
  else{
      //FRN_page is a variable that only means anything in the frankly environment
    if( (typeof FRN_page != 'object') || (typeof FRN_page.uri !== 'string'))
      return {}
    let searchString = FRN_page.uri.replace('http://www.newson6.com','').replace('http://www.news9.com','')
    let obj = parse(searchString.substring(1))
    return obj
  }
}

function parse(searchString){
  let arr = searchString.split('&')
  let obj = {}
  let i = arr.length;
  while (i--) {
    let pair = arr[i].split('=')
    if(pair.length != 2)
      return {}
    obj[pair[0]] = pair[1]
  }

  return obj

}

export default {
  params: params
}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Url.js